/* eslint no-underscore-dangle: 0 */
/**
 * Clasifica eventos de Blockly para saber qué bloque tocó cada usuario; lo usa
 * WorkSpaceClient para el resaltado por color. Basado en el original de navil@google.com.
 */
import * as Blockly from 'blockly/core';

export default class Position {
  constructor(type, blockId, fieldName) {
    this.type = type;
    this.blockId = blockId;
    this.fieldName = fieldName;
  }

  /**
   * Crea una Position a partir de un evento de Blockly.
   * @param {!Blockly.Events.Abstract} event
   * @param {boolean} throwError
   * @return {?Position}
   */
  static fromEvent(event, throwError = true) {
    const isCreateLike = (
      event.type === Blockly.Events.CREATE
      || event.type === Blockly.Events.MOVE
      || (event.type === Blockly.Events.CHANGE && event.element === 'mutation')
    ) && event.blockId;
    if (isCreateLike) {
      return this.fromCreateEvent_(event);
    }
    // Hoy no se alcanza: blockly.jsx filtra los eventos de selección antes de
    // WorkSpaceClient. Queda por si ese filtro cambia.
    if (event.type === Blockly.Events.SELECTED) {
      return this.fromSelectedEvent_(event);
    }
    if (event.type === Blockly.Events.CHANGE && event.element === 'field') {
      return this.fromFieldChangeEvent_(event);
    }
    if (throwError) {
      throw Error('Cannot create position from this event.');
    }
    return null;
  }

  static fromSelectedEvent_(event) {
    const type = 'BLOCK';
    const blockId = event.newElementId;
    const fieldName = null;
    return new Position(type, blockId, fieldName);
  }

  static fromCreateEvent_(event) {
    const type = 'BLOCK';
    const { blockId } = event;
    const fieldName = null;
    return new Position(type, blockId, fieldName);
  }

  static fromFieldChangeEvent_(event) {
    const type = 'FIELD';
    const { blockId } = event;
    const fieldName = event.name;
    return new Position(type, blockId, fieldName);
  }

  static fromJson(json) {
    return new Position(json.type, json.blockId, json.fieldName);
  }

  hasValidPosition() {
    if (this.type === 'FIELD' && this.blockId && this.fieldName) {
      return true;
    }
    if (this.type === 'BLOCK' && this.blockId) {
      return true;
    }
    return false;
  }
}
